import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEn from './en.json';
import translationFa from './fa.json';
import { DEFAULT_LOCALE } from './localeConfig';

export const i18setup = () => {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: translationEn },
      fa: { translation: translationFa }
    },
    lng: DEFAULT_LOCALE.language,
    fallbacking: DEFAULT_LOCALE.language,
    interpolation: { escapeValue: false }
  });
};
